'use strict';

angular.module('pmtPlacesApp.controllers').controller('ImportCtrl', [
	'$scope',
	'$stateParams',
	'$http',
	'Upload',
	'$location',
	'$timeout',
	function ($scope, $stateParams, $http, Upload, $location, $timeout) {
		let site = $stateParams.site;

		$scope.site = site;
		$scope.progressPercentage = 0;
		$scope.showUploadingProgress = false;
		$scope.showImportProgress = false;
		$scope.templateHelp = false;

		$scope.upload = function (files) {
			if (files && files.length) {
				let start = new Date().getTime();

				$scope.showUploadingProgress = true;

				let file = files[0];
				$scope.uploadingFile = file.name;

				$scope.progressPercentage = 0;
				$scope.importData = null;
				$scope.uploadError = null;
				Upload.upload({
					url: 'api/' + site + '/import/validate',
					file: file
				})
					.progress(function (evt) {
						$scope.progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
					})
					.success(function (data /*, status, headers, config*/) {
						if (data.success) {
							let end = new Date().getTime();
							let totalTime = end - start;
							let minTimeToShow = 2500; // milisec
							let delay = 0;
							if (totalTime < minTimeToShow) {
								delay = minTimeToShow - totalTime;
							}
							$timeout(function () {
								$scope.importData = data.data;
								$scope.uploadingFile = '';
								$scope.showUploadingProgress = false;
							}, delay);
						} else {
							$scope.uploadError = data.data;
							$scope.showUploadingProgress = false;
						}
					})
					.error(function (/*data, status, headers, config*/) {
						$scope.showUploadingProgress = false;
					});
			}
		};

		$scope.toggleHelp = function () {
			$scope.templateHelp = !$scope.templateHelp;
		};

		$scope.cancelImport = function () {
			$scope.importData = null;
			$scope.uploadError = null;
			$scope.progressPercentage = 0;
		};

		$scope.confirmImport = function () {
			$scope.showImportProgress = true;
			$http.post('api/' + site + '/import/confirm', $scope.importData).then(function (res) {
				$scope.confimedImportStatus = res.data;
			});
		};

		$scope.closeImportProgress = function () {
			$scope.showImportProgress = false;
			$scope.confimedImportStatus = null;
			$location.path('/' + site + '/tasks');
		};
	}
]);
